import HoverPopover from "./HoverPopover";
import { enrichPermissions } from "../../constants/aclPermissionCatalog";

function buildRoleLabel(name, level, objectName) {
  const roleName = String(name || "").trim();
  if (!roleName) return "";
  const scope =
    String(level || "").toLowerCase() === "app"
      ? "App"
      : String(objectName || "").trim() || "Client";
  return `${roleName}: ${scope}`;
}

export default function AclRolePopover({ role }) {
  if (!role) return null;

  const label = buildRoleLabel(role.name, role.level, role.objectName);
  if (!label) return null;

  const permissions = enrichPermissions(role.permissions || []).filter(
    (p) => Number(p.access) > 0,
  );

  return (
    <HoverPopover
      trigger={
        <span className="inline-block max-w-full cursor-default truncate rounded bg-gray-100 px-1 py-0.5 text-sm text-gray-800">
          {label}
        </span>
      }
    >
      <div className="font-medium text-gray-900">{label}</div>
      <div className="mt-2 space-y-2">
        {permissions.length === 0 ? (
          <div className="text-xs text-gray-500">None</div>
        ) : (
          permissions.map((p) => (
            <div key={p.value}>
              <div className="text-sm text-gray-900">{p.name}</div>
              {p.description ? (
                <div className="text-xs text-gray-600">{p.description}</div>
              ) : null}
            </div>
          ))
        )}
      </div>
    </HoverPopover>
  );
}
